/* eslint max-len: ["error", { "code": 160 }] */

// Improved on react/lib/cx.js
// by supporting nested arrays to allow for dynamic keys

function cx(classNames) {
  if (classNames instanceof Array) {
    const filteredClasses = [];
    classNames.forEach((className) => {
      if (typeof className === 'string') {
        filteredClasses[filteredClasses.length] = className;
      } else if (typeof className[1] === 'undefined' || !!className[1]) {
        filteredClasses[filteredClasses.length] = className[0]; // eslint-disable-line prefer-destructuring
      }
    });
    return Array.prototype.join.call(filteredClasses, ' ');
  }

  if (typeof classNames === 'object') {
    return Object.keys(classNames).filter((className) => classNames[className]).join(' ');
  }

  return Array.prototype.join.call(...classNames, ' ');
}

module.exports = cx;

// Basic example of how to use the Array-based syntax.
// Note the optional nested arrays, where the string is assumed as truthy

// {
//  className: cx([
//    'block',
//    ['block--active', this.state.isActive],
//    'block--key' + key
//  ])
// }
